import { gql } from '@apollo/client';
import { ContactFragment } from '../fragments/ContactFragment';
/**
 * @const UpdateContactMutation
 * @since 1.0.0
 */
export const UpdateContactMutation = gql `
  mutation UpdateContactMutation($input: UpdateContactInput!) {
    updateContact(input: $input) {
      ...ContactFragment
    }
  }

  ${ContactFragment}
`;
